module.exports = "<nav>\n    <ul class=\"menu\">\n      <li class=\"is-active\"><a routerLink=\"/login\" routerLinkActive=\"active\">Logout</a></li>\n      <li><a routerLink=\"/index/listitem\" routerLinkActive=\"active\">List Item</a></li>\n    </ul>\n </nav>\n<hr>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main